import React, { useState } from "react";
import {Link} from "react-router-dom";

// NO LONGER NEED TO IMPORT CSS: import '../styles/NewsletterPage.css';

const NewsletterPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    dateOfBirth: "",
  });
  const [status, setStatus] = useState("idle"); // 'idle', 'loading', 'success', 'error'
  const [message, setMessage] = useState("");

  const { fullName, email, dateOfBirth } = formData;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setMessage("");

    if (!fullName || !email || !dateOfBirth) {
      setStatus("error");
      setMessage("Please fill in all fields.");
      return;
    }

    if (!validateEmail(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    // --- THIS IS WHERE YOU WOULD CONNECT TO A BACKEND SERVICE ---
    console.log("Subscribing user:", formData);

    setTimeout(() => {
      setStatus("success");
      setMessage(
        `Thank you for subscribing, ${fullName}! Get ready for exclusive offers.`
      );
      setFormData({ fullName: "", email: "", dateOfBirth: "" });
    }, 1500);
  };

  return (
    // Main container with gradient background and centering
    <div className="bg-gradient-to-br from-green-100 to-green-150 min-h-screen flex justify-center items-center p-4">
      {/* Form card */}
      <div className="bg-white p-12 rounded-xl shadow-2xl w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Join Our Community
        </h1>
        <p className="text-gray-600 mb-8">
          Subscribe to our newsletter to get the latest updates, exclusive
          offers, and a special gift on your birthday!
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Full Name Field */}
          <div className="text-left">
            <label
              htmlFor="fullName"
              className="block text-sm font-semibold text-gray-700 mb-2"
            >
              Full Name
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={fullName}
              onChange={handleChange}
              placeholder="Enter Your Full Name"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
              required
            />
          </div>

          {/* Email Field */}
          <div className="text-left">
            <label
              htmlFor="email"
              className="block text-sm font-semibold text-gray-700 mb-2"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              placeholder="jane.doe@example.com"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
              required
            />
          </div>

          {/* Date of Birth Field */}
          <div className="text-left">
            <label
              htmlFor="dateOfBirth"
              className="block text-sm font-semibold text-gray-700 mb-2"
            >
              Date of Birth
            </label>
            <input
              type="date"
              id="dateOfBirth"
              name="dateOfBirth"
              value={dateOfBirth}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
              required
            />
            <small className="text-xs text-gray-500 mt-1">
              We'll use this to send you a special birthday treat.
            </small>
          </div>

          {/* Status Message */}
          {status && (
            <div
              className={`p-4 rounded-lg text-sm font-medium ${
                status === "success"
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {message}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#fe7590] text-white font-bold py-3 px-4 rounded-lg hover:bg-red-700 transition hover:-translate-y-1 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:transform-none cursor-pointer"
            disabled={status === "loading"}
          >
            {status === "loading" ? "Subscribing..." : "Subscribe"}
          </button>
          <div>
            “If you no longer wish to receive our emails, you can&nbsp; 
            <Link to={"/unsubscribe"} className="text-[#fe7590] hover:text-red-700">unsubscribe</Link>&nbsp;
            here at any time.”
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewsletterPage;
